import {
	//CREATE_PUBLICATIONS_FAILURE,
	FETCH_PUBLICATION_SUCCESS,
	FETCH_PUBLICATIONS_SUCCESS/*,
	SELECT_PUBLICATION,
	PUBLICATION_UPDATE*/
} from "./actions";

const initialState = {
	currently_loading_publications: false,
	publications_in_current_page: [],
	current_page: 0,
	total_publications: 0,
	total_pages: 0,
	new_publication_error: null,
	new_publication_request: {
		publication_name: null,
		ticker: null,
		risk_assessment_date: null,
		notes:null
	},
	selected_publication: {}
};


const reducerPublication = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PUBLICATIONS_SUCCESS:
			return {
				...state,
				current_page: action.page,
				publications_in_current_page: action.data,
				total_pages: action.total_pages
			};
			/*
		case SELECT_PUBLICATION:
			return {...state, selected_publication: {id: action.id}};
			*/
		case FETCH_PUBLICATION_SUCCESS:
			let response = action.data;
			return {
				...state, selected_publication: {
					id: action.id,
					publicationTitle: response.publicationTitle,
					publicationDate: response.publicationDate,
					publicationTypeName: response.publicationTypeName,
					publicationFile: response.publicationFile,
				}
			};/*
		case CREATE_PUBLICATIONS_FAILURE:
			return {
				...state,
				new_publication_error: action.error
			};

		case PUBLICATION_UPDATE:
			return {
				...state,
				UpdatePublicationResult: action.UpdatePublicationResult
			};*/
		default:
			return state
	}
};


export default reducerPublication;


// WEBPACK FOOTER //
// ./src/publications/redux/reducers.js